import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
/* istanbul ignore file */
i18n.use(initReactI18next).init({
    fallbackLng: 'en-US',
    lng: 'en-US',
    resources: {
        'en-US': {
            translations: require('../translations/en-US.json')
        },
        'de-DE': {
            translations: require('src/translations/de-DE.json')
        },
        'es-ES': {
            translations: require('src/translations/es-ES.json')
        },
        'fr-FR': {
            translations: require('src/translations/fr-FR.json')
        },
        'it-IT': {
            translations: require('src/translations/it-IT.json')
        },
        'ja-JP': {
            translations: require('src/translations/ja-JP.json')
        },
        'ko-KR': {
            translations: require('src/translations/ko-KR.json')
        },
        'pt-BR': {
            translations: require('src/translations/pt-BR.json')
        },
        'ru-RU': {
            translations: require('src/translations/ru-RU.json')
        },
        'th-TH': {
            translations: require('src/translations/th-TH.json')
        },
        'tr-TR': {
            translations: require('src/translations/tr-TR.json')
        },
        'zh-CN': {
            translations: require('src/translations/zh-CN.json')
        }
    },
    ns: ['translations'],
    defaultNS: 'translations'
});

export default i18n;
